'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

import { useMenus } from '@personly/libs-providers';

const className = classnames(
  'border-0',
  'inline-block',
  'align-middle',
  'text-menu-link-color',
  'bg-menu-background-color'
);

interface Props {
  children: ReactNode;
}

const MenuTogglerButton = ({ children }: Props) => {
  const { toggle } = useMenus();

  return (
    <button
      aria-label="Toggle Nav"
      onClick={toggle}
      type="button"
      className={className}
    >
      {children}
    </button>
  );
};

export default MenuTogglerButton;
